<template>
  <ui-dropdown
    class="ui-autocomplete"
    v-if="isShowAutocomplete"
    :container="container"
  >
    <ui-select-option-item
      class="ui-autocomplete__item"
      v-for="item in foundList"
      :key="item?.id ?? item[searchFieldName]"
      :value="item[searchFieldName]"
      @click="change(item)"
    >
      <slot name="item" :item="item" >
        <ui-highlight-subtext
          :text="item[searchFieldName]"
          :subtext="innerValue"
        />
      </slot>
    </ui-select-option-item>
  </ui-dropdown>
</template>

<script>
import UiDropdown from './UiDropdown.vue'
import UiSelectOptionItem from './select/UiSelectOptionItem.vue'
import UiHighlightSubtext from './UiHighlightSubtext.vue'

import innerValue from '../mixins/innerValue'
import apiMixin from '../mixins/apiMixin'

import { debounce, isSubstring } from '../libs/helpTools'
import axios from 'axios'

export default {
  components: { UiDropdown, UiSelectOptionItem, UiHighlightSubtext },
  mixins: [innerValue, apiMixin()],
  props: {
    isOpen: Boolean,
    value: String,
    entityName: String,
    container: HTMLElement,
    searchFieldName: {
      type: String,
      default: 'name'
    },
    minSearchFieldSize: {
      type: Number,
      default: 3
    },
    maxSearchFieldSize: {
      type: Number,
      default: 20
    },
    embed: String,
    list: Array
  },
  data () {
    return {
      foundList: []
    }
  },
  computed: {
    debounceSearch () {
      return debounce(this.getList, 500)
    },
    isShowAutocomplete () {
      return Boolean(this.isOpen && this.foundList.length)
    }
  },
  watch: {
    value () {
      if (!this.isOpen) {
        this.debounceSearch.cancel()
        return
      }
      this.debounceSearch()
    }
  },
  methods: {
    change (item) {
      this.innerValue = item[this.searchFieldName]
      this.$emit('change', item)
    },
    async getList () {
      const valueLength = this.innerValue?.length ?? 0
      if (
        (valueLength < this.minSearchFieldSize) ||
        (valueLength > this.maxSearchFieldSize)
      ) {
        this.foundList = []
        return
      }
      if (this.list?.length) {
        this.searchByList()
        return
      }
      this.cancelToken?.()
      try {
        this.loadingStart()
        if (this.isSearchApi) {
          this.foundList = await this.searchItems(
            this.value,
            {},
            { embed: this.embed }
          )
        } else {
          const res = await this.api?.getItems?.(
            {
              [this.searchFieldName]: this.value ?? null,
              embed: this.embed
            },
            new axios.CancelToken((c) => this.cancelToken = c)
          )
          this.foundList = res.data
        }
        this.loadingEnd()
      } catch (err) {
        if (axios.isCancel(err)) return
        this.loadingEnd()
        throw err
      }
    },
    searchByList () {
      this.foundList = this.list.filter(item => isSubstring(item[this.searchFieldName], this.value))
    },
    loadingStart () {
      this.$emit('loading-start')
    },
    loadingEnd () {
      this.$emit('loading-end')
    }
  }
}
</script>
